import React from 'react'

import { ViewTracker } from 'buyer-intent-sdk/react'

import { useBuyerIntentTrackingEnabled } from './BuyerIntentTrackingContext'
import ErrorBoundary from './ErrorBoundary'

/** @type {import("react").FC<{
 *  children?: import("react").ReactNode,
 *  sourceLocation?: string,
 *  context?: Record<string, unknown>,
 *  origin?: string,
 *  activityEndpoint?: string,
 *  userType?: string,
 *  distinctId?: string,
 * }>}
 */
const BuyerIntentPageView = ({ children, ...rest }) => {
  const trackingEnabled = useBuyerIntentTrackingEnabled()

  if (!trackingEnabled) {
    return <>{children}</>
  }

  return (
    <ErrorBoundary fallback={<>{children}</>}>
      <ViewTracker {...rest}>{children}</ViewTracker>
    </ErrorBoundary>
  )
}

export default BuyerIntentPageView
